import script from "./ExclusiveRecipe.vue?vue&type=script&setup=true&lang=js"
export * from "./ExclusiveRecipe.vue?vue&type=script&setup=true&lang=js"

import "./ExclusiveRecipe.vue?vue&type=style&index=0&id=0376c2a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0376c2a2"]])

export default __exports__